<template>
    <VueRecaptcha :sitekey="reCaptchaKey" ref="recaptcha" size="invisible" @verify="verify" :loadRecaptchaScript="true" />
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        name: "Captcha",

        components: { VueRecaptcha },

        inject: ['reCaptchaKey'],

        methods: {
            execute() {
                this.$refs.recaptcha.reset();
                this.$refs.recaptcha.execute();
            },

            verify(code) {
                this.$emit('verify', code)
            },
        },
    }
</script>
